module.exports = __webpack_public_path__ + "img/navbar-icon-logout.f4201496.svg";